import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TextFieldModule } from '@angular/cdk/text-field';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { sharedComponents, standaloneComponents } from './components';
import {
  CellFormatPipe,
  CompanyLinkPipe,
  CompanyTotalPipe,
  RowParamsPipe,
  RowWindowPipe,
  SanitizeHtmlPipe,
  SortRowsPipe,
} from './pipes';

import { RouterModule } from '@angular/router';

const sharedModules = [CommonModule, TranslateModule, NgxPermissionsModule];

const materialModules = [
  DragDropModule,
  MatButtonModule,
  MatCheckboxModule,
  MatMenuModule,
  MatProgressSpinnerModule,
  TextFieldModule,
  ...standaloneComponents,
];

const formModules = [FormsModule];

const sharedPipes = [
  CellFormatPipe,
  CompanyLinkPipe,
  CompanyTotalPipe,
  RowParamsPipe,
  RowWindowPipe,
  SanitizeHtmlPipe,
  SortRowsPipe,
];

@NgModule({
  declarations: [...sharedComponents, ...sharedPipes],
  imports: [
    CommonModule,
    TranslateModule,
    NgxPermissionsModule,
    RouterModule,
    ...materialModules,
    ...formModules,
  ],
  exports: [
    ...sharedModules,
    ...materialModules,
    ...formModules,
    ...sharedComponents,
    ...sharedPipes,
  ],
})
export class SharedModule {}
